<template>
  <v-row no-gutters>
    <v-col
      class="mb-2 ml-1 text-body-1"
      cols="12"
    >
      {{ label }}
    </v-col>
    <v-col class="mr-1">
      <validation-provider
        v-slot="{ errors }"
      >
        <number-input
          v-model="kilometers"
          outlined
          dense
          suffix="km"
          :placeholder="$t('label.e_g') + ' ' + 2"
          :decimal-precision="0"
          :error-messages="errors"
        />
      </validation-provider>
    </v-col>
    <v-col class="ml-1">
      <validation-provider
        v-slot="{ errors }"
      >
        <number-input
          v-model="meters"
          outlined
          dense
          suffix="m"
          :placeholder="$t('label.e_g') + ' ' + 500"
          :decimal-precision="0"
          :error-messages="errors"
        />
      </validation-provider>
    </v-col>
  </v-row>
</template>

<script>
  import NumberInput from '@/components/helpers/NumberInput.vue'

  export default {
    name: 'KilometerMeterInput',
    components: { NumberInput },
    props: {
      value: {
        type: [Number, null],
        default: null
      },
      label: {
        type: String,
        required: true
      },
      variable: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        kilometers: this.value ? Math.floor(this.value / 1000) : null,
        meters: this.value ? this.value % 1000 : null
      }
    },
    watch: {
      kilometers: function (val, oldVal) {
        this.$emit('input', val, this.meters, this.variable)
      },
      meters: function (val, oldVal) {
        this.$emit('input', this.kilometers, val, this.variable)
      }
    }
  }
</script>

<style scoped>

</style>
